import RoomSchedulingEdit from './RoomSchedulingEdit.vue';
export default RoomSchedulingEdit;
